import React from 'react';
import { BsArchive, BsCheck2Circle, BsTrash } from 'react-icons/bs';

import { analyticsIds } from '../../../../constants/analyticsIds';
import { inAppText } from '../../../../constants/inAppText';
import {
  adminPageSetCurrentDepartment,
  archiveDepartment,
  reactivateDepartment,
  resetAdminPageCurrentDepartment,
  resetMoveDepartmentData
} from '../../../../redux/modules/adminPage';
import { hideModal, showModal, updateModalOptions } from '../../../../redux/modules/modal';
import { showDontAskAgainModal } from '../../../../utils/askAgainModalUtil';
import { confirmDepartmentArchiveWithProcoreWarning } from '../../../../utils/procoreWarningModalUtil';
import { createToast } from '../../../../utils/toastUtil';
import ConfirmDeleteModalDepartment from '../../components/modals/ConfirmDeleteModalDepartment';

const showDeleteDepartmentModal = ({ dispatch, department, hasData }) => {
  dispatch(adminPageSetCurrentDepartment(department));
  dispatch(showModal(() => (
    <ConfirmDeleteModalDepartment
      checkForDataTransfer={hasData}
      data={department}
      hasData={hasData}
    />
  ), {
    actionRequired: true,
    size: 'lg',
    title: hasData ? 'Transfer Data?' : 'Delete Department?',
    onClose: () => {
      dispatch(resetMoveDepartmentData());
      dispatch(resetAdminPageCurrentDepartment());
    }
  }));
};

export const activeMenuOptions = (department, hasData) => ([
  {
    label: 'Archive Department',
    icon: BsArchive,
    id: 'archiveDepartment',
    dataAnalyticsId: analyticsIds.adminSettingsPage.departments.archiveDepartmentButton,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const departmentId = parseInt(e.target.value, 10);
      const cookieId = 'hideArchiveDepartmentModal';
      const archiveCurrentDepartment = async () => {
        dispatch(updateModalOptions({
          actionRequired: true,
          buttons: { primaryButtonOptions: { isLoading: true } }
        }));

        createToast({
          title: 'Archiving Department...',
          status: 'info',
          duration: 10000
        });

        await dispatch(archiveDepartment(departmentId));
        dispatch(hideModal());
      };

      confirmDepartmentArchiveWithProcoreWarning({
        dispatch,
        departmentId,
        cookieId,
        description: inAppText.adminPage.departments.archiveDepartment,
        onClick: archiveCurrentDepartment,
        title: 'Archive Department?'
      });
    }
  },
  {
    label: 'Delete Department',
    icon: BsTrash,
    id: 'deleteDepartment',
    dataAnalyticsId: analyticsIds.adminSettingsPage.departments.deleteDepartmentButton,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      showDeleteDepartmentModal({ dispatch, department, hasData });
    }
  }
]);

export const deactivatedMenuOptions = (department, hasData) => ([
  {
    label: 'Reactivate Department',
    icon: BsCheck2Circle,
    id: 'reactivateDepartment',
    dataAnalyticsId: analyticsIds.adminSettingsPage.departments.reactivateDepartmentButton,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const departmentId = parseInt(e.target.value, 10);
      const cookieId = 'hideReactivateDepartmentModal';
      const reactivateCurrentDepartment = async () => {
        dispatch(updateModalOptions({
          actionRequired: true,
          buttons: { primaryButtonOptions: { isLoading: true } }
        }));

        createToast({
          title: 'Reactivating Department...',
          status: 'info',
          duration: 10000
        });

        await dispatch(reactivateDepartment(departmentId));
        dispatch(hideModal());
      };

      showDontAskAgainModal({
        dispatch,
        cookieId,
        description: inAppText.adminPage.departments.archiveDepartment,
        onClick: reactivateCurrentDepartment,
        title: 'Reactivate Department?'
      });
    }
  },
  {
    label: 'Delete Department',
    icon: BsTrash,
    id: 'deleteDepartment',
    dataAnalyticsId: analyticsIds.adminSettingsPage.departments.deleteDepartmentButton,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      showDeleteDepartmentModal({ dispatch, department, hasData });
    }
  }
]);
